import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

const AUTH_KEY = "fenance_auth";
export const getStoredAuth = () => {
  try {
    return JSON.parse(localStorage.getItem(AUTH_KEY) || "null");
  } catch {
    return null;
  }
};
export const setStoredAuth = (auth) => {
  if (auth) localStorage.setItem(AUTH_KEY, JSON.stringify(auth));
  else localStorage.removeItem(AUTH_KEY);
};
const authHeader = () => {
  const a = getStoredAuth();
  return a?.token ? { Authorization: `Bearer ${a.token}` } : {};
};

export const ZONE_COLORS = {
  1: "#ef4444",
  2: "#f18e00",
  3: "#22c55e",
};

export const fetchTableau = async () => {
  const { data } = await api.get("/tableau");
  return data;
};

export const fetchHandlungsfeld = async (id) => {
  const { data } = await api.get(`/handlungsfelder/${id}`);
  return data;
};

export const createAssessment = async (payload) => {
  const { data } = await api.post("/assessments", payload, { headers: authHeader() });
  return data;
};

export const fetchAssessment = async (id) => {
  const { data } = await api.get(`/assessments/${id}`);
  return data;
};

export const requestReport = async (id, payload) => {
  const { data } = await api.post(`/assessments/${id}/report`, payload);
  return data;
};

export const reportDownloadUrl = (id) => `${API}/assessments/${id}/report.pdf`;

export const adminLogin = async (email, password) => {
  const { data } = await api.post("/auth/login", { email, password });
  return data;
};

export const registerUser = async (email, password, name) => {
  const { data } = await api.post("/auth/register", { email, password, name });
  return data;
};

export const loginUser = adminLogin; // same endpoint, role comes from response

export const fetchMe = async () => {
  const { data } = await api.get("/auth/me", { headers: authHeader() });
  return data;
};

export const fetchMyAssessments = async () => {
  const { data } = await api.get("/me/assessments", { headers: authHeader() });
  return data;
};

export const claimAssessment = async (id) => {
  const { data } = await api.post(`/assessments/${id}/claim`, {}, { headers: authHeader() });
  return data;
};

export const fetchFieldContent = async (token) => {
  const { data } = await api.get("/admin/field-content", {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
};

export const updateFieldContent = async (token, id, zitat) => {
  const { data } = await api.patch(`/admin/field-content/${id}`, { zitat }, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
};

export const fetchLeads = async (token) => {
  const { data } = await api.get("/admin/leads", {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
};

export const updateLead = async (token, id, patch) => {
  const { data } = await api.patch(`/admin/leads/${id}`, patch, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
};
